import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const ColorFilterPlaceholder = () => (
  <Placeholder
    type="round"
    loading
    className="!w-[40px] !h-[40px] md:!w-[20px] md:!h-[20px]"
  />
);

const ColorFiltersPlaceholder = () => (
  <div className="flex flex-row px-1 py-2 space-x-1 overflow-hidden">
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
    <ColorFilterPlaceholder />
  </div>
);

const UpholsterySortByPlaceholder = () => (
  <Placeholder
    type="rect"
    loading
    className="hidden md:block !w-[172px] !h-[38px] !m-0"
  />
);

const ColorFiltersAndSortByPlaceholder = () => (
  <div className="flex flex-row w-fit md:w-[460px] mb-4 md:mt-6 md:justify-between order-2 md:order-1">
    <ColorFiltersPlaceholder />
    <UpholsterySortByPlaceholder />
  </div>
);

const UpholsteryFilterPlaceholder = () => (
  <Placeholder
    type="rect"
    loading
    className="!w-[65px] !h-[31px] mb-1.5 rounded"
  />
);

const UpholsteryFiltersPlaceholder = () => (
  <div className="flex flex-row !min-w-[460px] md:mb-[22px] order-1 md:order-2">
    <UpholsteryFilterPlaceholder />
    <UpholsteryFilterPlaceholder />
    <UpholsteryFilterPlaceholder />
    <UpholsteryFilterPlaceholder />
    <UpholsteryFilterPlaceholder />
    <UpholsteryFilterPlaceholder />
  </div>
);

const ActiveFabricPlaceholder = () => (
  <Placeholder
    type="rect"
    loading
    className="!w-[175px] !h-[23px] mb-1.5 order-3"
  />
);

const MaterialThumbnailPlaceholder = () => (
  <Placeholder
    type="rect"
    loading
    className="!w-[55px] !h-[55px] md!:w-[40px] md:!h-[40px] !m-1 rounded-lg md:rounded-sm"
  />
);

const MaterialThumbnailsPlaceholder = () => (
  <div className="order-4">
    <div className="flex flex-row justify-evenly w-fit md:w-full">
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
    </div>
    <div className="flex flex-row justify-evenly w-fit md:w-full md:hidden">
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
      <MaterialThumbnailPlaceholder />
    </div>
  </div>
);

const SwatchKitButtonPlaceholder = () => (
  <Placeholder
    type="rect"
    loading
    className="!w-[212px] !h-[43px] !mt-4 rounded-full order-5"
  />
);

const PDPChooseYourOptionsPlaceholder = () => (
  <div className="flex flex-col">
    <ColorFiltersAndSortByPlaceholder />
    <UpholsteryFiltersPlaceholder />
    <ActiveFabricPlaceholder />
    <MaterialThumbnailsPlaceholder />
    <SwatchKitButtonPlaceholder />
  </div>
);

export default PDPChooseYourOptionsPlaceholder;
